import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.css";
import MainRoutes from "./pages/MainRoutes";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { store } from "./redux/store";
import { Toaster } from "sonner";
import analytics from "./helpers/analytics";
import { MonitoringProvider } from "./monitoring/MonitoringProvider";
import CgmMessageListener from "./components/cgm/CgmMessageListener";

// Initialize Analytics
analytics.initialize();

// Initialize React
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Render the app
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <MonitoringProvider>
          <CgmMessageListener />
          <Toaster richColors position="bottom-center" closeButton />
          <MainRoutes />
        </MonitoringProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
